<template>
    <v-container class="fill-height">
        <v-row align="center" justify="center">
            <v-col cols="7" class="text-center" v-if="!removed">
                Confirmar o recebimento de notificações?
                <br />
                <v-btn @click="acceptNotifications" :disabled="requestingApi">
                    Aceitar
                </v-btn>
            </v-col>
            <v-col cols="7" class="text-center" v-else>
                Número Aceito!
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import assets from "../assets/assets";
import api from '@/services'
export default {
    activated() {
        const vm = this;
        const urlParams = new URLSearchParams(window.location.search);

        vm.phoneNumber = urlParams.get('t');
    },
    data() {
        return {
            requestingApi: false,
            phoneNumber: '',
            accepted: false,
            assets: assets,
        };
    },
    methods: {
        acceptNotifications() {
            const vm = this;

            console.log(vm.phoneNumber);
            if (!vm.requestingApi) {
                vm.requestingApi = true;
                api.legalPerson.acceptNotifications(vm.phoneNumber).then((result) => {
                    console.log(result);
                    vm.accepted = true;
                }).catch((err) => {
                    if (err.message) {
                        vm.$notify({
                            type: "warn",
                            text: err.message,
                        });
                    }
                }).finally(() => {
                    vm.requestingApi = false;
                });
            }
        }
    }
};
</script>